module.exports = __webpack_public_path__ + "img/vip2.85293ac3.png";